import { ReferralFormState } from "@teamprevent/common/questionnaires/components/referralForm/models";

import {
    LOAD_HR_REPRESENTATIVES_SUCCESS,
    LOAD_LINE_MANAGERS_SUCCESS,
    LOAD_RECRUITMENT_MANAGERS_SUCCESS
} from "@teamprevent/common/questionnaires/components/referralForm/actionTypes";
import { ReferralFormAction } from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { OrgStructureAction } from "../crud/orgStructure/actions";

export const reducer = (
    state: ReferralFormState = { hrRepresentatives: [], orgLevels: [], lineManagers: [], recruitmentManagers: [] },
    action: OrgStructureAction | ReferralFormAction): ReferralFormState => {
    switch (action.type) {
        case "LOAD_ORGSTRUCTURES_SUCCESS":
            const newOrgLevels = action.payload.filter(orgLevel => !state.orgLevels.find(l => l.id === orgLevel.id));
            return {
                ...state,
                orgLevels: [
                    ...state.orgLevels,
                    ...newOrgLevels.map(
                        l => ({ id: l.id, name: l.name, parentId: l.level > 0 ? l.ascendantIds[l.ascendantIds.length - 1] : null }))]
            };
        case LOAD_HR_REPRESENTATIVES_SUCCESS:
            return {
                ...state,
                hrRepresentatives: action.payload
            };
        case LOAD_RECRUITMENT_MANAGERS_SUCCESS:
            return {
                ...state,
                recruitmentManagers: action.payload
            };
        case LOAD_LINE_MANAGERS_SUCCESS:
            return {
                ...state,
                lineManagers: action.payload
            };
        default:
            return state;
    }
};
